import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export const VWSIcon = () => {
  const theme = useTheme();
  const { mode } = theme.palette;

  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 42 42"
    >
      <path
        d="M0 0 C10.2670112 4.53402239 10.2670112 4.53402239 12 8 C12.09813199 10.49082076 12.13905548 12.94733789 12.125 15.4375 C12.13080078 16.4594043 12.13080078 16.4594043 12.13671875 17.50195312 C12.1306374 20.60648046 11.98890312 23.03329065 11 26 C8.48828125 27.60546875 8.48828125 27.60546875 5.3125 29.1875 C4.27738281 29.71730469 3.24226563 30.24710938 2.17578125 30.79296875 C-2.51153495 32.57449484 -5.48846505 32.57449484 -10.17578125 30.79296875 C-11.72845703 29.99826172 -11.72845703 29.99826172 -13.3125 29.1875 C-14.36050781 28.66542969 -15.40851562 28.14335937 -16.48828125 27.60546875 C-19 26 -19 26 -20 23 C-20.14728053 20.48490177 -20.23083395 18.01554365 -20.25 15.5 C-20.270625 14.82324219 -20.29125 14.14648438 -20.3125 13.44921875 C-20.3515091 8.50481525 -20.3515091 8.50481525 -18.74609375 6.19921875 C-17.88177734 5.60560547 -17.88177734 5.60560547 -17 5 C-16.34644531 4.54238281 -15.69289063 4.08476563 -15.01953125 3.61328125 C-10.13211012 0.73273039 -5.75184268 -1.48666166 0 0 Z M-9.1875 5 C-9.90292969 5.37125 -10.61835938 5.7425 -11.35546875 6.125 C-12.16951172 6.558125 -12.16951172 6.558125 -13 7 C-10.13201967 10.02254214 -7.25582327 12.52172653 -3 13 C0.29888037 11.75701964 3.11393478 10.00912023 6 8 C0.58470783 3.87352476 -2.72360922 1.60910647 -9.1875 5 Z "
        fill={mode === 'dark' ? '#fff' : '#757575'}
        transform="translate(20,0)"
      />
    </SvgIcon>
  );
};
